import React from 'react'
import style from './style.scss'
import BrowseIcon from '~/icons/BrowseIcon'

export const PreviewContainer = ({faviconURL, pageTitle, isFaviconAvailable, workspaceId}) => {

    const faviconPath = isFaviconAvailable ? `/api/v1/bots/___/media/${workspaceId}/${faviconURL}` : faviconURL
    const title = pageTitle || 'EnableX Dialogs'

    return <>
        <div className={style.previewContainer}>
            <div className="chrome_tab_container">
                <div className="chrome_tab_list">
                    <div className="chrome_tab active_tab">
                        <div className="inner">
                            <span className="border_left"></span>
                            <span className="border_right"></span>
                            <div className="icon">{ faviconPath ? <img src={faviconPath}></img> : <BrowseIcon />}</div>
                            <div className="text">{title}</div>
                            <div className="remove_tab"></div>
                        </div>
                    </div>
                </div>
                <div className="chrome_tab_settings">
                    {/* <div className="add_tab" title="New Tab"></div> */}
                    <div className="exit"></div>
                    <div className="maximize"></div>
                    <div className="minimize"></div>
                </div>
            </div>
        </div>
    </>
}
